import Frames from "@frog/source/engine/animating/Frames.js"

export default {
    "frames": Frames.run({
        "tweentime": 80,
        "images": [
            require("./fireanim-torchfancy-flame3-0000.png"),
            require("./fireanim-torchfancy-flame3-0001.png"),
            require("./fireanim-torchfancy-flame3-0002.png"),
            require("./fireanim-torchfancy-flame3-0003.png"),
            require("./fireanim-torchfancy-flame3-0004.png"),
            require("./fireanim-torchfancy-flame3-0005.png"),
            require("./fireanim-torchfancy-flame3-0006.png"),
            require("./fireanim-torchfancy-flame3-0007.png"),
        ]
    })
}
